import { z } from 'zod';

export const workflowTriggerTypeEnum = z.enum([
  'manual',
  'event',
  'schedule',
  'webhook',
]);

export const workflowStepTypeEnum = z.enum([
  'transform',
  'send_email',
  'call_webhook',
  'create_record',
  'delay',
  'condition',
  'query_notion',
  'send_slack_message',
]);

const triggerConfigSchema = z.object({
  type: workflowTriggerTypeEnum,
  config: z.record(z.unknown()).default({}),
});

const workflowStepSchema = z.object({
  id: z.string().min(1),
  type: workflowStepTypeEnum,
  name: z.string().min(1).max(100),
  config: z.record(z.unknown()).default({}),
});

export const createWorkflowSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100),
  script: z.string().default(''),
  description: z.string().max(500).optional(),
  trigger: triggerConfigSchema.optional(),
  steps: z.array(workflowStepSchema).optional(),
});

export const updateWorkflowSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  script: z.string().optional(),
  description: z.string().max(500).nullable().optional(),
  trigger: triggerConfigSchema.optional(),
  steps: z.array(workflowStepSchema).optional(),
  status: z.enum(['draft', 'active', 'paused', 'archived']).optional(),
});

export const workflowsQuerySchema = z.object({
  page: z.coerce.number().min(1).default(1),
  pageSize: z.coerce.number().min(1).max(100).default(20),
  status: z.enum(['draft', 'active', 'paused', 'archived']).optional(),
  search: z.string().optional(),
});

export const workflowRunsQuerySchema = z.object({
  page: z.coerce.number().min(1).default(1),
  pageSize: z.coerce.number().min(1).max(100).default(20),
  status: z.enum(['pending', 'running', 'completed', 'failed', 'cancelled']).optional(),
});

export const triggerWorkflowSchema = z.object({
  data: z.record(z.unknown()).default({}),
});

export type CreateWorkflowInput = z.infer<typeof createWorkflowSchema>;
export type UpdateWorkflowInput = z.infer<typeof updateWorkflowSchema>;
export type WorkflowsQueryInput = z.infer<typeof workflowsQuerySchema>;
export type WorkflowRunsQueryInput = z.infer<typeof workflowRunsQuerySchema>;
export type TriggerWorkflowInput = z.infer<typeof triggerWorkflowSchema>;
